/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {NoteId, NoteInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditClientNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/clients/${id}/notes/${noteId}`;
};

/**
 * @summary Edit client note
 */
export const editClientNote = async (
  id: string,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditClientNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveClientNoteUrl = (id: string, noteId: NoteId) => {
  return `/api/v1/sales/clients/${id}/notes/${noteId}`;
};

/**
 * @summary Remove client note
 */
export const removeClientNote = async (
  id: string,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveClientNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddClientNoteUrl = (id: string) => {
  return `/api/v1/sales/clients/${id}/notes`;
};

/**
 * @summary Add client note
 */
export const addClientNote = async (
  id: string,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddClientNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};
